import { BlockService } from '@blocksuite/block-std';

import type { PiqueLatexBlockModel } from './latex-block';

export class PiqueLatexBlockService extends BlockService<PiqueLatexBlockModel> {
  override mounted(): void {
    super.mounted();
  }
}
